/**
 * Runtime Configuration Utility
 *
 * Provides synchronous access to interpolated config values from app.config.json
 * This reads directly from the interpolated app-config for use in constructors.
 *
 * SECURITY: Only functions that need backend URL should be called server-side
 */
import appConfigRaw from '@/app.config.json';
import { interpolateConfig } from '@/core/config/interpolation';

// Interpolate config once at module load
const appConfig = interpolateConfig(appConfigRaw);

/**
 * Get the backend URL from app.config.json (interpolated with env vars)
 *
 * SECURITY: This should ONLY be called server-side
 * Throws error if called on client to prevent accidental exposure
 */
export function getBackendUrl(): string {
  if (typeof window !== 'undefined') {
    throw new Error('getBackendUrl() can only be called server-side. Backend URL should never be exposed to client.');
  }
  return appConfig.api.backendUrl || 'http://api.example.com';
}

/**
 * Get the API base URL
 */
export function getApiBaseUrl(): string {
  return appConfig.api.baseUrl || '/api';
}

/**
 * Get full interpolated app config (synchronous)
 */
export function getAppConfig() {
  return appConfig;
}
